import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { TableMotives, pickMotive } from './tableMotives';

export type StyledTableProps = {
  motive?: TableMotives;
};

const TableWrapper = styled.div`
  ${mediaMinWidth.md(css`
    display: block;

    overflow: scroll;
  `)}
`;

const Table = styled.table<StyledTableProps>`
  width: 100%;

  border-spacing: 0px;
  white-space: nowrap;

  ${({ motive }) => motive && pickMotive(motive)};

  td {
    vertical-align: middle;
  }

  /* Extra spacing for Technologies table: gap between image (first column) and technology name */
  &.tech-table {
    td:first-child {
      padding-right: 2rem;
    }
    img {
      width: unset !important;
    }
    /* Row separator between items */
    tbody tr:not(:last-child) td {
      border-bottom: 0.1rem solid ${pickColor('borderExtraLight')};
    }
  }
`;

export { Table, TableWrapper };
